// Вывод слэш-команды панели (README §2а):
//
//   > /usage
//      Лимиты Claude
//      окно 5 часов          осталось 62 %
//        сброс               02:40 МСК · через 1 ч 12 мин
//
// Строка ввода — цветом ввода, блок — с отступом 3ch и линией слева 2px
// --term-faint, заголовок 12 px --term-dim, пары «ключ — значение» (ключ
// --term-dim, 190 px). Это вывод панели, глифа «⏺» у него нет.

import { memo } from 'react'
import { useAppStore } from '../../store/appStore'
import type { LogLine } from '../../store/logStore'

/** Длинную ссылку (вход в MCP по OAuth — сотни знаков) показываем коротко:
 *  хост и «…», полный адрес — в href. */
function shortUrl(url: string) {
  if (url.length <= 80) return url
  try {
    return `${new URL(url).host}/… — открыть`
  } catch {
    return `${url.slice(0, 60)}…`
  }
}

/** Ссылки в подсказке команды — кликабельные. */
function linkify(note: string) {
  const parts = note.split(/(https?:\/\/[^\s)]+)/)
  if (parts.length === 1) return note
  return parts.map((part, i) => (i % 2 === 1
    ? <a key={i} className="t-link" href={part} target="_blank" rel="noreferrer">{shortUrl(part)}</a>
    : part))
}

function CmdBlock({ line }: { line: LogLine }) {
  const cmd = line.cmd
  if (cmd?.divider) {
    return (
      <div className="t-row t-row--head cli-cmd">
        <span className="t-gut">{line.gutter ?? '>'}</span>
        <span className="t-txt">
          <span className="cli-cmd__input">{line.text}</span>
          <span className="cli-divider">{`── ${cmd.title || 'новый разговор'} ──`}</span>
          {cmd.notes.map((n, i) => <span key={i} className="cli-cmd__note">{n}</span>)}
        </span>
      </div>
    )
  }
  return (
    <div className="cli-cmd t-row--head">
      <div className="t-row t-row--me cli-cmd__head">
        <span className="t-gut">{line.gutter ?? '>'}</span>
        <span className="t-txt">{line.text}</span>
      </div>
      {cmd ? (
        <div className={`cli-cmd__block${cmd.ok ? '' : ' is-fail'}`}>
          {cmd.title ? <div className="cli-cmd__title">{cmd.title}</div> : null}
          {cmd.rows.map((row, i) => (
            <div className="cli-cmd__row" key={i}>
              {row.open ? (
                <button
                  type="button"
                  className="cli-cmd__key cli-cmd__open"
                  title="открыть беседу"
                  onClick={() => useAppStore.getState().focusSession(row.open as string)}
                >
                  {row.key}
                </button>
              ) : <span className="cli-cmd__key">{row.key}</span>}
              <span className={`cli-cmd__val${row.tone ? ` is-${row.tone}` : ''}`}>{row.value}</span>
            </div>
          ))}
          {cmd.notes.map((note, i) => (
            <div className="cli-cmd__note" key={`n${i}`}>{linkify(note)}</div>
          ))}
        </div>
      ) : line.partial ? (
        <div className="cli-cmd__block"><div className="cli-cmd__title">выполняю…</div></div>
      ) : null}
    </div>
  )
}

export default memo(CmdBlock)
